/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".display-hours-radio-group[_ngcontent-%COMP%]{display:inline-flex;flex-direction:column;margin:5px}.display-hours-radio-btn[_ngcontent-%COMP%]{margin:3px}.closed-holidays-field[_ngcontent-%COMP%]{width:75%}.display-hours-label[_ngcontent-%COMP%]{font-size:1em;margin-bottom:5px}.display-hours-radio-btn[_ngcontent-%COMP%]{font-size:.75em}"];
export { styles as styles };
